var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { addDashIfNullOrUndefined } from "./numberMethods";
export var objectValidation = function (data, keys) {
    Object.entries(data).map(function (_a, i) {
        var _b = __read(_a, 2), k = _b[0], v = _b[1];
        if (typeof v === "string" || typeof v === "number") {
            if (keys && keys.length > 0) {
                keys.map(function (ck) {
                    if (ck == k) {
                        data[k] = addDashIfNullOrUndefined(v);
                    }
                });
            }
            else {
                data[k] = addDashIfNullOrUndefined(v);
            }
        }
    });
    return data;
};
export function isEmpty(value) {
    if (value === null || value === undefined || value === "")
        return true;
    if (Array.isArray(value) && value.length === 0)
        return true;
    if (typeof value === "object" && value !== null && Object.keys(value).length === 0)
        return true;
    return false;
}
export function fromEntries(entries) {
    return entries.reduce(function (acc, _a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        acc[key] = value;
        return acc;
    }, {});
}
export function removeEmptyKeyValuesPairs(obj) {
    return fromEntries(Object.entries(obj).filter(function (_a) {
        var _b = __read(_a, 2), _ = _b[0], value = _b[1];
        return !isEmpty(value);
    }));
}
export var isZero = function (val) {
    return val === "0.00" || val === "0" || val === "0.0" ? true : false;
};
export var removeTrailingZeroes = function (value) {
    if (!value.includes("."))
        return value; // Return if no decimal point
    return value.replace(/(\.\d*?[1-9])0+$|\.0*$/, "$1");
};
